<template>
    <v-form ref="etapeValidation" id="etapeValidation" v-model="$storeCandidature.etapeValidationValide" lazy-validation>
        <v-container grid-list-md text-xs-center>
            <h3 class="text-md-left">
                {{$storeCandidature.langueFormulaire == 'en' ? 'Please check that all the information you have entered is correct' : 'Merci de valider que tous les renseignements que vous avez saisis sont exacts'}}
            </h3>
            <!-- Zone Identification -->
            <Comp_Valid_Identification etape="1"></Comp_Valid_Identification>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone choix du programme -->
            <Comp_Valid_ChoixProgramme etape="2"></Comp_Valid_ChoixProgramme>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Information Supplémentaire-->
            <v-form ref="etapeValidationInfoSup" id="etapeValidationInfoSup" v-model="$storeCandidature.ValidationInformationSupplementaireOK" lazy-validation>
                <v-card>
                    <h3 v-if="$storeCandidature.langueFormulaire != 'en'" class="text-md-center font-weight-black" style="text-decoration: underline;">Etape 3 : Informations Complémentaires 1/2</h3>
                    <h3 v-if="$storeCandidature.langueFormulaire == 'en'" class="text-md-center font-weight-black" style="text-decoration: underline;">Etape 3 : More information 1/2</h3>

                    <v-layout row wrap xs12 mx-3
                              v-if="$storeCandidature.sasCandidature.Ecole
                              && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce">
                        <v-flex xs4>
                            <v-text-field readonly label="N° INE"
                                          :value="$storeCandidature.sasCandidature.InformationsComplementaires.NumIne"
                                          :rules="[$rules.required($storeCandidature.langueFormulaire)]" placeholder=" ">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Academy' : 'Académie'"
                                          :value="$storeCandidature.sasCandidature.InformationsComplementaires.Academie && ($storeCandidature.langueFormulaire == 'en' ? $storeCandidature.sasCandidature.InformationsComplementaires.Academie.Lang01 : $storeCandidature.sasCandidature.InformationsComplementaires.Academie.Lang00)"
                                          :rules="[$rules.required($storeCandidature.langueFormulaire)]" placeholder=" ">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                   
                    <div id="terminale" class="mx-3">
                        <v-layout row wrap>
                            <h3>Terminale :</h3>
                            <hr size="5" width="100%" color="secondary">
                        </v-layout>
                        <v-layout row wrap xs12>
                            <v-flex xs4>
                                <v-text-field readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire'" :rules="[$rules.required($storeCandidature.langueFormulaire)]" placeholder=" "
                                              :value="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.AnneeTerminale && ($storeCandidature.langueFormulaire == 'en' ? $storeCandidature.sasCandidature.ParcoursScolaireTerminale.AnneeTerminale.Lang01 : $storeCandidature.sasCandidature.ParcoursScolaireTerminale.AnneeTerminale.Lang00)">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs2 class="pl-2">
                                <v-switch readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Repetition' : 'Redoublement'" v-model="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.RedoublementTerminale"></v-switch>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap xs12>
                            <v-flex xs4>
                                <v-text-field v-if="!$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre"
                                              readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name' : 'Etablissement fréquenté'" :rules="[$rules.required($storeCandidature.langueFormulaire)]" placeholder=" "
                                              :value="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale && $storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementTerminale.Label">
                                </v-text-field>
                                <v-text-field v-if="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre"
                                              readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name' : 'Nom établissement'" placeholder=" "
                                              :value="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.EtablissementAutre">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution postcode' : 'Code postal établissement'" :rules="[$rules.required($storeCandidature.langueFormulaire)]" placeholder=" "
                                              :value="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.CpTerminale">
                                </v-text-field>
                            </v-flex>
                            <v-flex xs4>
                                <v-text-field readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution city' : 'Ville établissement'" :rules="[$rules.required($storeCandidature.langueFormulaire)]" placeholder=" "
                                              :value="$storeCandidature.sasCandidature.ParcoursScolaireTerminale.VilleTerminale">
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </div>
                   
                    <v-layout row wrap xs12 mx-3>
                        <v-flex xs4>
                            <v-switch readonly :label="$storeCandidature.langueFormulaire == 'en' ? 'Do you practice a high level activity?' : 'Pratiquez-vous une activité de haut niveau ?'" v-model="$storeCandidature.sasCandidature.LoisirsVieAssociative.ActiviteHautNiveau"
                                      title="On distingue une activité de haut niveau si et seulement si elle est de niveau National (ex : sélectionné au Championnat de France) ou International (ex : sélectionné au JO)">
                            </v-switch>
                        </v-flex>
                        <v-flex xs4 v-if="$storeCandidature.sasCandidature.LoisirsVieAssociative.ActiviteHautNiveau">
                            <v-text-field readonly v-model="$storeCandidature.sasCandidature.LoisirsVieAssociative.Activite"
                                          :label="$storeCandidature.langueFormulaire == 'en' ? 'Activity' : 'Activité'">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs4 v-if="$storeCandidature.sasCandidature.LoisirsVieAssociative.ActiviteHautNiveau">
                            <v-text-field readonly v-model="$storeCandidature.sasCandidature.LoisirsVieAssociative.NiveauDivision"
                                          :label="$storeCandidature.langueFormulaire == 'en' ? 'Level or division' : 'Niveau ou division'">
                            </v-text-field>
                        </v-flex>
                    </v-layout>
                    

                </v-card>
            </v-form>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Pièce à joindre-->
            <Comp_Valid_PiecesJointe etape="4"></Comp_Valid_PiecesJointe>
            <v-layout row wrap xs12 my-2></v-layout>

            <!-- Zone Payement-->
            <Comp_Valid_Paiement etape="5"></Comp_Valid_Paiement>

            <!--Consentement-->
            <v-layout row wrap xs12 my-2></v-layout>
            <v-card mt-2>
                <h3 class="text-md-center font-weight-black" style="text-decoration: underline;">{{$storeCandidature.langueFormulaire == 'en' ? 'Step 6 : Data entered is correct' : 'Etape 6 : Données exactes'}}</h3>
                <v-switch class="pa-2"
                          :label="$storeCandidature.langueFormulaire == 'en' ? 'I certify that my data entered is correct. Any fraud or attempted fraud in the information provided, when submitting a request, may give rise to sanctions which may go as far as the cancellation of the registration and therefore the loss of any right or advantage obtained.'
                          : 'Je certifie que mes données saisies sont exactes. Toute fraude ou tentative de fraude dans les renseignements fournis, lors du dépôt de candidature, peut donner lieu à des sanctions allant jusqu\'a l\'invalidation de l\'inscrption et donc la perte de tout droit ou avantage obtenus'"
                          :readonly="!$storeCandidature.sasCandidature.Statut || $storeCandidature.sasCandidature.Statut.Id != $storeCandidature.configurationClient.StatutCandidatureEnCoursId"
                          v-model="$storeCandidature.sasCandidature.Identification.CertifiDonneeCorrect" :rules="[$rules.accepterCertification($storeCandidature.langueFormulaire)]"></v-switch>
            </v-card>
        </v-container>
    </v-form>
</template>

<script>
    import Comp_Valid_ChoixProgramme from "../components/CompValidationChoixProgramme";
    import Comp_Valid_Identification from "../components/CompValidationIdentification";
    import Comp_Valid_PiecesJointe from "../components/CompValidationPiecesJointes";
    import Comp_Valid_Paiement from "../components/CompValidationPaiement";

    export default {
        components: {
            Comp_Valid_ChoixProgramme,
            Comp_Valid_Identification,
            Comp_Valid_PiecesJointe,
            Comp_Valid_Paiement

        },

        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,
                testcheck: false,

                // Header liste frères et soeures
                headerFreresSoeurrs: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'First name' : 'Prénom', value: 'prenom' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Last name' : 'Nom', value: 'nom' },
                    { text: 'Age', value: 'age' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Gender' : 'Sexe', value: 'sexe' },
                    { text: 'Situation', value: 'situation' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' }
                ],

                // Header Langue
                headerLangues: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Language' : 'Langue', value: 'langue' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree name' : 'Nom dipôme', value: 'nomdiplome' },
                ],             
            }
        },

        methods: {
            // Formatage de la date
            formatDate(date) {
                if (date) { return this.$moment(String(date)).format('DD/MM/YYYY') }
                else { return '' }
            },
        }
    }
</script>

<style>
</style>